// extracted by mini-css-extract-plugin
export default {"container":"FalakMedia_container__rSibq"};